import { Component, Input, OnChanges, SecurityContext } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-svg-icon",
  template: `<span *ngIf="svgIcon" [innerHTML]="svgIcon"></span>`,
  styleUrls: ["./svg-icon.component.scss"],
})
export class SvgIconComponent implements OnChanges {
  @Input()
  public url?: string;

  @Input()
  public isActive?: boolean;

  public svgIcon: any;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  public ngOnChanges(): void {
    if (!this.url) {
      this.svgIcon = "";
      return;
    }
    if (!this.svgIcon) {
      this.httpClient
        .get(this.url, { responseType: "text" })
        .subscribe((value) => {
          this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
        });
    }
  }
}
